var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.001172%",
    y1: "90.6254938%",
    x2: "18.1262081%",
    y2: "0.0015081765%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D989B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#045F61",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calculatrice-1",
    transform: "translate(-30.000000, -61.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-1",
    transform: "translate(30.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1899714,8.76403146e-06 C38.8064714,-0.00294644267 41.3693714,0.741521797 43.5772714,2.1455278 L33.1479714,12.5768778 C32.1086714,12.1212778 30.9859714,11.8864778 29.8512714,11.8873778 L20.1498714,11.8873778 C17.9595714,11.8894778 15.8597714,12.7603778 14.3106714,14.3089778 C12.7616714,15.8574778 11.8901714,17.9571778 11.8873714,20.1474778 L11.8873714,22.9020778 L0,22.9020778 L0,13.8108778 C0,11.9971778 0.357086387,10.2013778 1.05111139,8.5257378 C1.74513139,6.8501078 2.76230139,5.3273978 4.04476139,4.0449378 C5.32721139,2.7624878 6.84976139,1.7451478 8.52539139,1.0511278 C10.2009714,0.357107797 11.9970714,8.76403146e-06 13.8106714,8.76403146e-06 L36.1899714,8.76403146e-06 Z M29.8512714,16.4342778 L20.1498714,16.4342778 C19.1650714,16.4349778 18.2208714,16.8261778 17.5240714,17.5221778 C16.8273714,18.2181778 16.4350714,19.1619778 16.4332714,20.1468778 L16.4332714,29.8509778 C16.4344714,30.8361778 16.8264714,31.7803778 17.5232714,32.4768778 C18.2200714,33.1734778 19.1646714,33.5651778 20.1498714,33.5660778 L29.8512714,33.5660778 C30.8363714,33.5651778 31.7809714,33.1734778 32.4775714,32.4768778 C33.1740714,31.7803778 33.5656714,30.8359778 33.5665714,29.8509778 L33.5665714,20.1468778 C33.5649714,19.1622778 33.1730714,18.2183778 32.4765714,17.5224778 C31.7800714,16.8265778 30.8357714,16.4355778 29.8512714,16.4348778 L29.8512714,16.4342778 Z M38.1119714,20.1468778 L38.1119714,29.8509778 C38.1134714,31.6012778 37.5559714,33.3061778 36.5206714,34.7174778 L46.8132714,45.0107778 C48.8766714,42.5336778 50.0045714,39.4107778 49.9999854,36.1868778 L49.9999854,13.8102778 C50.0040714,10.6721778 48.9340714,7.6270278 46.9679714,5.1813378 L36.6653714,15.4859778 C37.6090714,16.8571778 38.1135714,18.4829778 38.1119714,20.1474778 L38.1119714,20.1468778 Z M29.8512714,38.1106778 L20.1498714,38.1106778 C17.9595714,38.1083778 15.8596714,37.2374778 14.3106714,35.6887778 C12.7616714,34.1401778 11.8901714,32.0405778 11.8873714,29.8502778 L11.8873714,27.4453778 L1.60930362e-08,27.4453778 L1.60930362e-08,36.1868778 C1.60930362e-08,39.8498778 1.45477139,43.3630778 4.04476139,45.9534778 C6.63474139,48.5438778 10.1476714,49.9989778 13.8106714,49.9993933 L36.1892714,49.9993933 C38.7207714,50.0031778 41.2040714,49.3078778 43.3652714,47.9895778 L32.8985714,37.5227778 C31.9295714,37.9116778 30.8953714,38.1125778 29.8512714,38.1142778 L29.8512714,38.1106778 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3753b4d33bd0c5bdb128fb80e8dbf97c.svg";
export { ForwardRef as ReactComponent };